"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var cnpj_1 = require("../cnpj");
var cpf_1 = require("../cpf");
exports.checkValidCPFOrCNPJ = function (strCpfOrCnpj) {
  var valutToValid = strCpfOrCnpj.replace(/[^\d]+/g, '');
  return valutToValid.length > 11 ? cnpj_1.checkValidCNPJ(strCpfOrCnpj) : cpf_1.checkValidCPF(strCpfOrCnpj);
};